import React from "react";
import BaseComponent from "../../BaseComponent.js";
import styled from "styled-components";
import nota from "../../Global/nota.guidelines.json";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

import dailyUpdateService from "../../../services/DailyUpdateService.js";

const multiple = nota.global.multiple;

const StyledLetter = styled(NanoFlex)``;

export class Letter extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      idLetter: Number(this.props.render.match.params.id),
      html: "",
    };
  }

  componentDidMount() {
    super.componentDidMount();

    this.getLetter();
  }

  componentDidUpdate(prevProps, prevState) {}

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  getLetter = () => {
    dailyUpdateService
      .getDailyUpdateLetter(this.state.idLetter)
      .then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          // Catch
          if ((response.status === 403 || response.status === 401)) window.dispatchEvent(new Event("sendToLogin"));
        }
      })
      .then((data) => {
        // this.setState({ html: data });
        if (data && data !== "undefined") {
          document.open();
          document.write(data);
          document.close();
        } else {
          this.props.render.history.push("/");
        }
      });
  };

  render() {
    return <StyledLetter></StyledLetter>;
  }
}
